import { render, staticRenderFns } from "./Page03.vue?vue&type=template&id=2ca9acf7&scoped=true&"
import script from "./Page03.vue?vue&type=script&lang=js&"
export * from "./Page03.vue?vue&type=script&lang=js&"
import style0 from "./Page03.vue?vue&type=style&index=0&id=2ca9acf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca9acf7",
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QSpace,QSelect,QIcon,QInput,QPopupProxy,QDate,QTabs,QTab,QSeparator,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign({QToolbar,QToolbarTitle,QSpace,QSelect,QIcon,QInput,QPopupProxy,QDate,QTabs,QTab,QSeparator,QTabPanels,QTabPanel}, component.options.components || {})
